import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-picklist',
  templateUrl: './picklist.component.html',
  styleUrls: ['./picklist.component.scss']
})
export class PicklistComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
